import Popup from "../../lib/Popup";

import * as PIXI from "pixi.js";
import gsap from "gsap";
import { IGameSnacks } from "../../lib/GameSnacks";
import ServiceLocator from "../../ServiceLocator";
import Utils from "../../Utils";
import Button from "../../lib/Button";
import { Profile } from "../../lib/game_snacks/IUser";
import Session, { game_type } from "../../Session";
import { LiveEventData, LiveEventDataType, LivePlayerDataEvent, LivePresenceAction } from "../../lib/game_snacks/ILiveMultiplayer";
import { Signal } from "signals";
import PRNG from "../../lib/PRNG";
import { IStartGamePayload } from "./MatchMakingPopup";
import PlayerSlot from "./PlayerSlot";
import { game_event_type } from "../../service/MultiplayerEventManager";
import Settings from "../Settings";
import TutorialPopup from "./TutorialPopup";

declare global {
    interface Window { GameSnacks: IGameSnacks; }
}


export default class GuestPrivateRoomPopup extends Popup
{
    // #region Attributes //

    // private:

    private _gameType: number = null;

    private _classicModeBtn: Button = null;
    private _pointsModeBtn: Button = null;
    private _gameStartedBg: PIXI.Sprite = null;
    private _versus: PIXI.Sprite = null;
    private _versusExplosion: PIXI.Sprite = null;
    private _headerText: PIXI.Text = null;
    private _footerText: PIXI.Text = null;
    private _arrPlayerSlot: Array<PlayerSlot> = null;
    private _settings: Settings = null;
    private _backBtn: Button = null;

    private _isGameStarted: boolean = null;

    private _gameReadyTl: gsap.core.Timeline = null;

    private _onGameStarted: Signal = null;

    // #endregion //


    public set gameType( value: number ) { this._gameType = value; }

    public get onGameStarted(): Signal { return this._onGameStarted; } 


    // #region Methods //

    // public:

    public onEnter(): void
    {
        super.onEnter();        

        this._onGameStarted = new Signal();

        this._arrPlayerSlot = [];
        this._isGameStarted = false;

        let bg: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.matchmaking_background_01.texture );
        bg.anchor.set( 0.5 );
        bg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._root.addChild( bg );

        this._gameStartedBg = new PIXI.Sprite( ServiceLocator.resources.matchmaking_background_02.texture );
        this._gameStartedBg.visible = false;
        this._gameStartedBg.anchor.set( 0.5 );
        this._gameStartedBg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._root.addChild( this._gameStartedBg );

        this._versusExplosion = new PIXI.Sprite( ServiceLocator.resources.vs_background_effect.texture );
        this._versusExplosion.visible = false;
        this._versusExplosion.anchor.set( 0.5 );
        this._versusExplosion.position.set( ServiceLocator.app.width * 0.5, 619 );
        this._root.addChild( this._versusExplosion );

        this._headerText = new PIXI.Text( "Play With Friends", { fontFamily: "jaro_regular", fontSize: 80, fill: 0xffffff, stroke: 0x000000, strokeThickness: 12, letterSpacing: 2 } );
        this._headerText.anchor.set( 0.5 );
        this._headerText.position.set( ServiceLocator.app.width * 0.5, 158 );
        this._root.addChild( this._headerText );

        let gameModeText: PIXI.Text = new PIXI.Text( "Selected game mode:", { fontFamily: "jaro_regular", fontSize: 40, fill: 0xffffff } );
        gameModeText.anchor.set( 0.5 );
        gameModeText.position.set( ServiceLocator.app.width * 0.5, 270 );
        this._root.addChild( gameModeText );

        this._classicModeBtn = new Button( { on: "button_mode_classic", pressed: "button_mode_classic_pressed" } );
        this._classicModeBtn.interactive = false;
        this._classicModeBtn.anchor.set( 0.5 );
        this._classicModeBtn.position.set( 217, 371 );
        this._root.addChild( this._classicModeBtn );

        this._pointsModeBtn = new Button( { on: "button_mode_301_off", pressed: "button_mode_301_pressed" } );
        this._pointsModeBtn.interactive = false;
        this._pointsModeBtn.anchor.set( 0.5 );
        this._pointsModeBtn.position.set( 421, 371 );
        this._root.addChild( this._pointsModeBtn );

        if ( this._gameType == game_type.CLASSIC_PRIVATE )
        {
            this._classicModeBtn.setTextures( { on: "button_mode_classic", pressed: "button_mode_classic_pressed" } );
            this._pointsModeBtn.setTextures( { on: "button_mode_301_off", pressed: "button_mode_301_pressed" } );
        }
        else
        {
            this._classicModeBtn.setTextures( { on: "button_mode_classic_off", pressed: "button_mode_classic_pressed" } );
            this._pointsModeBtn.setTextures( { on: "button_mode_301", pressed: "button_mode_301_pressed" } );
        }

        const kArrPos: Array<PIXI.Point> = [ 
            new PIXI.Point( 158, 614 ),
            new PIXI.Point( ServiceLocator.app.width - 158, 614 ) ];
        for ( let i: number = 0; i < Session.i.kGameRoomSize; ++i )
        {
            let playerSlot: PlayerSlot = new PlayerSlot( ServiceLocator.resources.matchmaking_avatar_base.texture );
            playerSlot.position.copyFrom( kArrPos[ i ] );
            this._root.addChild( playerSlot );            
            //
            this._arrPlayerSlot.push( playerSlot );
        }
        this._arrPlayerSlot[ 0 ].setPlayer( Session.i.profile );
        this._updateOtherPlayerSlots();
        
        this._versus = new PIXI.Sprite( ServiceLocator.resources.vs.texture );
        this._versus.visible = false;
        this._versus.anchor.set( 0.5 );
        this._versus.position.set( ServiceLocator.app.width * 0.5 + 8, 605 );
        this._root.addChild( this._versus );

        this._backBtn = new Button( { on: "button_back", pressed: "button_back_pressed" } );
        this._backBtn.anchor.set( 0.5 );
        this._backBtn.position.set( 48, 44 + 16 );
        this._root.addChild( this._backBtn );
        this._backBtn.on( "pointertap", () => { 
            this._root.interactiveChildren = false;
            if ( window.GameSnacks )
            {
                window.GameSnacks.liveMultiplayer.updatePlayerPresence( LivePresenceAction.LEAVE )
                    .then( () => {
                        this._onClosed.dispatch( this ); 
                    } );
            }
            else
            {
                this._onClosed.dispatch( this ); 
            }
        } );

        this._footerText = new PIXI.Text( "Waiting for the Host to start the game...", { fontFamily: "jaro_regular", fontSize: 40, fill: 0xffffff } );
        this._footerText.anchor.set( 0.5 );
        this._footerText.position.set( ServiceLocator.app.width * 0.5, 900 );
        this._root.addChild( this._footerText );

        this._settings = new Settings();
        this._settings.init( true );
        this._settings.position.set( 592, 7 + 16 );
        this._root.addChild( this._settings );
        this._settings.onTutorial.add( () => { 
            let tutorialPopup: TutorialPopup = new TutorialPopup();
            tutorialPopup.init();
            this._root.addChild( tutorialPopup );
            tutorialPopup.onClosed.add( ( popup: TutorialPopup ) => {
                popup.end();
            } );
        } );
        this._settings.onHome.addOnce( () => { 
            this._root.interactiveChildren = false;
            window.GameSnacks.liveMultiplayer.updatePlayerPresence( LivePresenceAction.LEAVE )
                .then( () => {
                    this._root.interactiveChildren = true;

                    this._onClosed.dispatch( this ); 
                } );
        } );

        ServiceLocator.multiplayerEventManager.onPlayerPresenceUpdated.add( this._onMultiplayer_PlayerPresenceUpdated, this );
        ServiceLocator.multiplayerEventManager.onEventsReceived.add( this._onMultiplayer_EventsReceived, this );
        ServiceLocator.multiplayerEventManager.onProfileChange.add( this._onProfile_Changed, this );

        window.GameSnacks.liveMultiplayer.sendEvent( { payload: JSON.stringify( { type: game_event_type.JOINED_PRIVATE_ROOM, uid: Session.i.profile.uid, dartSkinIndex: ServiceLocator.saved.data.selDartIndex } ) } );
    }

        private _onMultiplayer_PlayerPresenceUpdated( presenceEventPromise: Promise<LivePlayerDataEvent> ): void
        {
            presenceEventPromise
                .then( ( livePlayerDataEvent: LivePlayerDataEvent ) => {
                    if ( livePlayerDataEvent.action == LivePresenceAction.JOIN )
                    {
                        let profile: Profile = livePlayerDataEvent.profile;
                        profile.uid = livePlayerDataEvent.uid;
                        Session.i.room.push( livePlayerDataEvent.profile );

                        if ( profile.uid == Session.i.profile.uid )
                        {
                            this._arrPlayerSlot[ 0 ].setPlayer( profile );
                        }
                        this._updateOtherPlayerSlots();
                    }
                    else if ( livePlayerDataEvent.action == LivePresenceAction.LEAVE )
                    {
                        if ( this._isGameStarted )
                        {
                            if ( Session.i.profile.uid != livePlayerDataEvent.uid ) 
                            {
                                for ( let i: number = 0; i < Session.i.room.length; ++i )
                                {
                                    if ( Session.i.room[ i ].uid == livePlayerDataEvent.uid )
                                    {
                                        Session.i.room[ i ].isBot = true;
                                        break;
                                    }
                                }
                            }
                        }
                        else
                        {
                            if ( Session.i.room[ 0 ].uid == livePlayerDataEvent.uid )
                            {
                                Utils.showMessagePopup( "The host left the room." );

                                this._onClosed.dispatch( this ); 
                            }
                            else
                            {
                                if ( Session.i.profile.uid != livePlayerDataEvent.uid ) 
                                {
                                    for ( let i: number = 0; i < Session.i.room.length; ++i )
                                    {
                                        if ( Session.i.room[ i ].uid == livePlayerDataEvent.uid )
                                        {
                                            Session.i.room.splice( i, 1 );
                                            break;
                                        }
                                    }

                                    this._updateOtherPlayerSlots();
                                }
                            }
                        }
                    }
                    else if ( livePlayerDataEvent.action == LivePresenceAction.HOST_CHANGED )
                    {
                        window.GameSnacks.liveMultiplayer.updatePlayerPresence( LivePresenceAction.LEAVE )
                            .then( () => {
                                Utils.showMessagePopup( "The host left the room." );

                                this._onClosed.dispatch( this ); 
                            } );
                    }   
                } );
        }

            private _updateOtherPlayerSlots(): void
            {
                for ( let i: number = 1; i < Session.i.kGameRoomSize; ++i )
                {
                    this._arrPlayerSlot[ i ].empty();
                }

                let myProfileIndex: number = 0;
                while ( Session.i.room[ myProfileIndex ].uid != Session.i.profile.uid )
                {
                    myProfileIndex += 1;
                }

                let playerCount: number = 1;
                let playerProfileIndex: number = myProfileIndex + 1;
                if ( playerProfileIndex > Session.i.room.length - 1 )
                {
                    playerProfileIndex = 0;
                }
                let playerSlotIndex: number = 1;
                //
                while ( playerCount < Session.i.room.length )
                {
                    this._arrPlayerSlot[ playerSlotIndex ].setPlayer( Session.i.room[ playerProfileIndex ] );

                    playerProfileIndex += 1;
                    if ( playerProfileIndex > Session.i.room.length - 1 )
                    {
                        playerProfileIndex = 0;
                    }
                    playerSlotIndex += 1;

                    playerCount += 1;
                }
            }

        private _onMultiplayer_EventsReceived( eventsPromise: Promise<LiveEventData[]> ): void
        {
            eventsPromise
                .then( ( arrData: LiveEventData[] ) => {
                    let isStartGame: boolean = false;
                    while ( arrData.length > 0 )
                    {
                        let data: LiveEventData = arrData.shift();
                        if ( !this._isGameStarted && data.payload )
                        {
                            const kPayload: any = JSON.parse( data.payload );
                            if ( kPayload.type == game_event_type.PRIVATE_GAME_TYPE_UPDATED )
                            {
                                this._gameType = kPayload.gameType;

                                if ( this._gameType == game_type.CLASSIC_PRIVATE )
                                {
                                    this._classicModeBtn.setTextures( { on: "button_mode_classic", pressed: "button_mode_classic_pressed" } );
                                    this._pointsModeBtn.setTextures( { on: "button_mode_301_off", pressed: "button_mode_301_pressed" } );
                                }
                                else
                                {
                                    this._classicModeBtn.setTextures( { on: "button_mode_classic_off", pressed: "button_mode_classic_pressed" } );
                                    this._pointsModeBtn.setTextures( { on: "button_mode_301", pressed: "button_mode_301_pressed" } );
                                }
                            }
                            else
                            {
                                let startGamePayload: IStartGamePayload = JSON.parse( data.payload );
                                if ( data.type !== LiveEventDataType.START_GAME
                                    && ( startGamePayload as any ).type !== game_event_type.PLAY_AGAIN_PRIVATE_GAME )
                                {
                                    startGamePayload = null;
                                }

                                if ( startGamePayload )
                                {
                                    Session.i.prng = new PRNG( startGamePayload.seed );
                                    Session.i.room = startGamePayload.room;

                                    isStartGame = true;
                                }
                            }
                        }
                        else
                        {
                            Session.i.gameEvents.push( data );
                        }
                    }

                    if ( isStartGame )
                    {
                        this._isGameStarted = true;

                        this._backBtn.interactive = false;
                        gsap.to( this._backBtn, { alpha: 0, duration: 0.4, ease: "linear.inOut" } );

                        this._settings.interactive = false;
                        gsap.to( this._settings, { alpha: 0, duration: 0.4, ease: "linear.inOut" } );

                        this._footerText.text = "All ready! Let's Play!";

                        this._gameStartedBg.visible = true;
                        this._gameStartedBg.alpha = 0;
                        //
                        this._versusExplosion.visible = true;
                        this._versusExplosion.scale.set( 1, 0 );
                        //
                        this._versus.visible = true;
                        this._versus.scale.set( 0 );
                        //
                        this._gameReadyTl = new gsap.core.Timeline();
                        this._gameReadyTl.to( this._gameStartedBg, { alpha: 1, duration: 1.6, ease: "sine.out" }, 0 );
                        this._gameReadyTl.to( this._versusExplosion.scale, { y: 1, duration: 0.8, ease: "expo.out" }, 0 );
                        this._gameReadyTl.to( this._versus.scale, { x: 1, y: 1, duration: 1, ease: "back.out" }, 0 );
                        this._gameReadyTl.call( () => { this._onGameStarted.dispatch( this, this._gameType ); }, null, ">+2" );

                        ServiceLocator.audio.playSfx( "matchmaking_found" );
                        ServiceLocator.audio.stopMusic();
                    }
                } );
        }

        private _onProfile_Changed( profile: Profile): void
        {
            ( Session.i.profile.avatar as any ) = profile.avatar;
            ( Session.i.profile.username as any ) = profile.username;

            this._arrPlayerSlot[ 0 ].setPlayer( Session.i.profile )
        }

    public onLeave(): void
    {
        this._onGameStarted.dispose();
        this._onGameStarted = null;

        ServiceLocator.multiplayerEventManager.onPlayerPresenceUpdated.removeAll();
        ServiceLocator.multiplayerEventManager.onEventsReceived.removeAll();
        ServiceLocator.multiplayerEventManager.onProfileChange.remove( this._onProfile_Changed, this );

        if ( this._gameReadyTl )
        {
            this._gameReadyTl.kill();
            this._gameReadyTl = null;
        }

        this._settings.end();
        this._settings = null;

        super.onLeave();
    }

    // #endregion //
}